import {forward, guard} from 'effector';
import i18next from 'i18next';
import {toast} from 'react-toastify';

import {authBroadcast} from 'core/broadcastAuth';
import {RestError, showRestError} from 'core/errors';
import {TokenStorage} from 'core/tokenStorage';

import {
    authSyncReceived,
    cleanAuthData,
    cleanAuthDataFx,
    createOrganizationFx,
    doLogin,
    doLoginWithCert,
    doLogout,
    loadProfileFx,
    loginError$,
    loginFx,
    loginRedirectFromPrevPath$,
    loginWithCertFx,
    logoutFx,
    profile$,
    reloadPageFx,
} from './index';

profile$
    .on(loadProfileFx.doneData, (state, data) => data)
    .on(loginFx.doneData, (state, [{profile}]) => profile)
    .on(loginWithCertFx.doneData, (state, [{profile}]) => profile)
    .reset(cleanAuthDataFx.finally);

loginError$.on(loginFx.failData, (state, {message}) => message).reset(loginFx.done);

loginRedirectFromPrevPath$.on(doLogout, (state, payload) => payload);

forward({
    from: doLogin,
    to: loginFx,
});

forward({
    from: doLoginWithCert,
    to: loginWithCertFx,
});

forward({
    from: doLogout.map(() => TokenStorage.refreshToken),
    to: logoutFx,
});

forward({
    from: logoutFx.done,
    to: cleanAuthDataFx,
});

forward({
    from: cleanAuthData,
    to: cleanAuthDataFx,
});

authBroadcast.subscribe((message) => {
    authSyncReceived(message.type);
});

guard({
    clock: authSyncReceived,
    filter: (type) => type === 'LOGIN',
    target: reloadPageFx,
});

loginFx.doneData.watch(([authData, saveCredentials]) =>
    TokenStorage.storeTokens(authData, saveCredentials),
);
loginWithCertFx.doneData.watch(([authData]) => TokenStorage.storeTokens(authData, true));

createOrganizationFx.doneData.watch(() =>
    toast.success(i18next.t('pages.register.message.success')),
);

loginFx.failData.watch((err) => showRestError(err as RestError));
loginWithCertFx.failData.watch((err) => showRestError(err as RestError));
// loadProfileFx.failData.watch((err) => showRestError(err as RestError));
logoutFx.failData.watch((err) => showRestError(err as RestError));
createOrganizationFx.failData.watch((err) => showRestError(err as RestError));
